module.exports = __webpack_public_path__ + "static/media/Minior_gaussian2.7bcb7efe.png";